
export default () => {

  if( window.baguetteBox ) {
    window.baguetteBox.destroy()
    //window.baguetteBox.run('.dz-details.gallery-modal', {
    window.baguetteBox.run('.order-detail__dropzone.dropzone-previews', {
      animation: 'fadeIn',
      buttons: true,
      filter: new RegExp(/.+\.(gif|jpe?g|png|webp|pdf|cdr|eps|bmp|svg|ai)/i),
      ignoreClass: 'dz-download-link',
      // noScrollbars: true,
      overlayBackgroundColor: 'hsla(223, 80%, 63%, 0.5)',
      afterShow: () => {
        document.documentElement.classList.add('-is-modal-opened')
      },
      afterHide: () => {
        document.documentElement.classList.remove('-is-modal-opened')
      },
      onChange: (currentIndex, imagesCount) => {
        //console.log('baguetteBox change')
        const baguetteBoxFigure = document.querySelector('#baguetteBox-figure-'+currentIndex)
        const baguetteBoxFigureImg = document.querySelector('#baguetteBox-figure-'+currentIndex+' img')

        if( baguetteBoxFigureImg ) {
          let src = baguetteBoxFigureImg.getAttribute('src')

          //console.log(src)

          let originalItemFile = document.querySelector('.dz-details.gallery-modal[href="'+src+'"]')

          if( !originalItemFile ) {
            let srcForSearch = src.replace(window.location.protocol + "//" + window.location.host, '')
            originalItemFile = document.querySelector('.dz-details.gallery-modal[href="'+srcForSearch+'"]')
          }

          if( originalItemFile ) {
            const preview = originalItemFile.getAttribute('data-preview')
            if( preview ) {
              baguetteBoxFigureImg.setAttribute('src', preview)
              baguetteBoxFigureImg.setAttribute('alt', originalItemFile.getAttribute('data-download'))
            }
          }


          let alt = ''
          if( baguetteBoxFigureImg.getAttribute('alt') ) {
            alt = baguetteBoxFigureImg.getAttribute('alt')
            //baguetteBoxFigureImg.setAttribute('download', alt)

            if( !baguetteBoxFigure.querySelector('.img-wrap') ) {
              let imgLink = document.createElement('a');
              imgLink.href = src;
              imgLink.setAttribute('download', alt)
              imgLink.setAttribute('target', '_blank')

              let imgWrap = document.createElement('div');
              imgWrap.appendChild(baguetteBoxFigureImg)
              imgWrap.classList.add('img-wrap')

              imgWrap.appendChild(imgLink)

              baguetteBoxFigure.appendChild(imgWrap)
            }
            else {
              let imgLink = baguetteBoxFigure.querySelector('.img-wrap a')
              if( imgLink ) {
                src = imgLink.getAttribute('href')
              }
            }
          }

          if( !document.querySelector('.modal-download') ) {
            let div = document.createElement('div');
            div.classList.add('modal-download')
            document.getElementById('baguetteBox-overlay').appendChild(div);
          }

          let btnLabel = 'Скачать'
          if( document.documentElement.lang === 'en' ) {
            btnLabel = 'download'
          }
          else if ( document.documentElement.lang === 'fr' ) {
            btnLabel = 'télécharger'
          }
          else if ( document.documentElement.lang === 'de' ) {
            btnLabel = 'herunterladen'
          }

          document.querySelector('.modal-download').innerHTML = '<a class="modal-download__link" href="'+src+'" target="_blank" download="'+alt+'">'+ btnLabel +' <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg></a>'
        }
      },
    })
  }
}

